import DiagnosisResultView from '@/components/feature/diagnosis/DiagnosisResultView';
import Footer from '@/components/feature/Footer';
import Header from '@/components/feature/Header';
import {
  CODE_TO_META,
  getDiagnosisResultByCode,
  isDiagnosisResultComplete,
  type MbtiCode,
} from '@/data/diagnosisResults';
import { appStoreUrlDiagnosisResultCta, googlePlayUrlDiagnosisResultCta } from '@/utils/appStoreUtm';

/**
 * 診断結果ページのファクトリ
 * 各 `diagnosis-result{N}/page.tsx` から `createDiagnosisResultPage('PALZ')` の1行で呼ぶ
 */
export function createDiagnosisResultPage(code: MbtiCode) {
  const meta = CODE_TO_META[code];

  return function DiagnosisResultPage() {
    const data = getDiagnosisResultByCode(code);
    const showDraftBanner = !isDiagnosisResultComplete(code);

    return (
      <>
        <Header />
        {showDraftBanner && (
          <div
            style={{
              background: '#FFF8E6',
              color: '#8A5A00',
              fontSize: 12,
              fontWeight: 700,
              textAlign: 'center',
              padding: '6px 12px',
              borderBottom: '1px solid #F4E2C2',
            }}
          >
            {meta.code}（{meta.name}）— コンテンツ準備中（レイアウトプレビュー）
          </div>
        )}
        <DiagnosisResultView
          data={data}
          appStoreHref={appStoreUrlDiagnosisResultCta(String(meta.pageNumber))}
          googlePlayHref={googlePlayUrlDiagnosisResultCta(String(meta.pageNumber))}
        />
        <Footer />
      </>
    );
  };
}
